import { request } from './apiClient';

// Lista os corpos de prova de uma obra.
export const getCorpoProvaPorObra = async (idObra) => {
    return await request(`/api/corpoProva/CPObra/${idObra}`);
};

// Cria um corpo de prova.
export const createCorpoProva = async (corpoProvaData) => {
    return await request("/api/corpoProva", {
        method: 'POST',
        body: JSON.stringify(corpoProvaData)
    });
};

// Atualiza um corpo de prova por id.
export const updateCorpoProva = async (idCorpoProva, corpoProvaData) => {
    return await request(`/api/corpoProva/${idCorpoProva}`, {
        method: 'PUT',
        body: JSON.stringify(corpoProvaData)
    });
};

// Exclui um corpo de prova por id.
export const deleteCorpoProva = async (idCorpoProva) => {
    return await request(`/api/corpoProva/${idCorpoProva}`, {
        method: 'DELETE'
    });
};